const STORAGE_PREFIX = "trekkin.navGrid.dedupe";

const DEFAULT_SETTINGS = Object.freeze({
  enabled: true,
  meters: 15,
});

const normalizeScope = (scope) => (scope === "import" ? "import" : "record");

const normalizeMeters = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed >= 1 ? parsed : DEFAULT_SETTINGS.meters;
};

export function readNavGridDedupeSettings(scope = "record", storage = globalThis?.localStorage) {
  const key = `${STORAGE_PREFIX}.${normalizeScope(scope)}`;
  try {
    const raw = storage?.getItem?.(key);
    if (!raw) return { ...DEFAULT_SETTINGS };
    const parsed = JSON.parse(raw);
    return {
      enabled: parsed?.enabled !== false,
      meters: normalizeMeters(parsed?.meters),
    };
  } catch {
    return { ...DEFAULT_SETTINGS };
  }
}

export function saveNavGridDedupeSettings(
  scope = "record",
  settings = DEFAULT_SETTINGS,
  storage = globalThis?.localStorage
) {
  const normalized = {
    enabled: settings?.enabled !== false,
    meters: normalizeMeters(settings?.meters),
  };
  try {
    storage?.setItem?.(
      `${STORAGE_PREFIX}.${normalizeScope(scope)}`,
      JSON.stringify(normalized)
    );
  } catch {}
  return normalized;
}

